var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6282_5529",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6282_5529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69836 17.6531L1.39453 12.3493L2.46373 11.2955L6.71373 15.5455L7.05993 15.1993L8.11373 16.2531L6.69836 17.6531ZM12.3484 17.6531L7.04453 12.3493L8.09836 11.2801L12.3484 15.5301L21.5484 6.33008L22.6022 7.39928L12.3484 17.6531ZM12.0022 12.3493L10.933 11.2955L15.883 6.34545L16.9522 7.39928L12.0022 12.3493Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/completedIcon.1ff017ed432769a77dc41280d2d48359.svg";
export { ForwardRef as ReactComponent };